import { render, staticRenderFns } from "./ObjetivosMensualesHistoricos.vue?vue&type=template&id=050d5898&"
import script from "./ObjetivosMensualesHistoricos.vue?vue&type=script&lang=js&"
export * from "./ObjetivosMensualesHistoricos.vue?vue&type=script&lang=js&"
import style0 from "./ObjetivosMensualesHistoricos.vue?vue&type=style&index=0&id=050d5898&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports